import { Box, FloraTypography } from '@grupoboticario/flora-react'

import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'

import CollapsibleSection from './CollapsibleSection'
import DateTimeDisplay from './DateTimeDisplay'
import InfoField from './InfoField'
import {
  displaySectionContentStyle,
  displayFieldTitleStyle,
  displayFieldValueStyle,
  disclaimerStyle,
  disclaimerTextStyle,
  descriptionTitleStyle
} from './styles'

const DisplaySection = ({ isOpen, onToggle, selectedBrands, formValues }) => (
  <CollapsibleSection isOpen={isOpen} onToggle={onToggle} title={PREVIEW_LABELS.SECTION_DISPLAY} variant="compact">
    <Box css={displaySectionContentStyle}>
      <InfoField label={PREVIEW_LABELS.FIELD_BRANDS} value={selectedBrands} />

      <Box css={displayFieldTitleStyle}>
        <FloraTypography css={descriptionTitleStyle} fontSize="exceptionsAuxiliar">
          {PREVIEW_LABELS.FIELD_START}
        </FloraTypography>
      </Box>
      <Box css={displayFieldValueStyle}>
        <DateTimeDisplay date={formValues.redeemStart?.data} time={formValues.redeemStart?.hora} />
      </Box>

      <Box css={displayFieldTitleStyle}>
        <FloraTypography css={descriptionTitleStyle} fontSize="exceptionsAuxiliar">
          {PREVIEW_LABELS.FIELD_END}
        </FloraTypography>
      </Box>
      <Box css={displayFieldValueStyle}>
        <DateTimeDisplay date={formValues.redeemEnd?.data} time={formValues.redeemEnd?.hora} />
      </Box>

      <Box css={disclaimerStyle}>
        <FloraTypography css={disclaimerTextStyle} fontSize="exceptionsAuxiliar">
          {PREVIEW_LABELS.DISPLAY_DISCLAIMER}
        </FloraTypography>
      </Box>
    </Box>
  </CollapsibleSection>
)

export default DisplaySection
